import React from 'react';
import IconButton from './Button/IconButton';

type ButtonGroupProps = {
  className?: string;
  children: React.ReactNode;
};

function ButtonGroup({className, children}: ButtonGroupProps) {
  /** Find first/last indexes of IconButton to give rounded-border left/right respectively */
  let firstButtonIndex = -1;
  let lastButtonIndex = -1;
  React.Children.forEach(children, (child, index) => {
    if (React.isValidElement(child)) {
      if (child.type === IconButton) {
        if (firstButtonIndex < 0) {
          firstButtonIndex = index;
        }

        lastButtonIndex = index;
      }
    }
  });

  return (
    <div className={className}>
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
          if (child.type === IconButton) {
            const {className} = child.props;

            return React.cloneElement(child, {
              className: `h-14 w-14 relative border-skyblue border ${
                firstButtonIndex === index ? 'rounded-l-large' : ''
              } ${
                lastButtonIndex === index ? 'rounded-r-large' : ''
              } focus:bg-aliceblue ${className || ''}`,
            });
          }
        }
        return child;
      })}
    </div>
  );
}

export default ButtonGroup;
